export const getNameByFile = (file: string): string => {
  const splitResult = file.split(/[/\\]/);
  return splitResult.pop() || '';
};

export const getNumberOnly = (file: string): string => {
  return file.match(/\d+/)!.toString();
}